export const AUTHENTICATE_SUCCESS = "AUTHENTICATE_SUCCESS";
export const AUTHENTICATE_FAILED = "AUTHENTICATE_FAILED";
export const SET_IS_LOADING = "SET_IS_LOADING";
export const SET_BRANCH_ID = "SET_BRANCH_ID";
export const LOGOUT = "LOGOUT";
